import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { Button } from '@ps-design-system/components/Button';
import { validateScheduleDay } from '@ps-design-system/components/ScheduleInputField';
import { useCheckoutContext } from '../CheckoutContextProvider';
import { useStripeElementsContext } from '../StripeElementsContextProvider';
import { canInstantBook } from '../checkout-utils';
import { NEW_CARD_OPTION } from '../checkout-forms/PaymentForm/CreditCardSelectField';
import { ExpressCheckoutButton } from './ExpressCheckoutButton';

export const BookingSubmitButton = ({
  handleRequestSuccess,
  checkTransactability,
  disabled,
}) => {
  const {
    quote,
    isFetchingQuote,
    bookingDetailsForm,
    listing,
    submitRequest,
    isSubmittingRequest,
    paymentForm,
    collectFormsValues
  } = useCheckoutContext();

  const { stripeElements } = useStripeElementsContext();

  const selectedPaymentMethod = paymentForm.watch('selectedPaymentMethod');

  const submitPaymentElement = async () => {
    // Validate stripe payment element form if used
    const selectedPaymentMethod = paymentForm.getValues('selectedPaymentMethod');
    const selectedCard = paymentForm.getValues('selectedCreditCard');
    const isNewCard = selectedCard?.id === NEW_CARD_OPTION.id;
    const isCreditCardPayment = !selectedPaymentMethod || selectedPaymentMethod === 'card';
    if (isCreditCardPayment && isNewCard) {
      try {
        const submissionResult = await stripeElements?.submit();
        if (submissionResult.error) {
          return;
        }
        return submissionResult;
      } catch (e) {
        return;
      }
    }
    return true;
  };

  const handleCreditCardSubmit = () => {
    checkTransactability(async () => {
      // Collect values and validate the form
      const validateElementResult = await submitPaymentElement();
      const formValues = await collectFormsValues();
      if ((!formValues || formValues.error) || (!validateElementResult || validateElementResult.error)) {
        return;
      }

      const requestRes = await submitRequest(formValues);

      if (!requestRes || requestRes.error) {
        // if no response, form validation failed
        return;
      }

      handleRequestSuccess(requestRes);
    });
  };

  const { booking } = quote?.spaceRentalContract?.meta || {};

  const validScheduleDays = (bookingDetailsForm.watch('schedule') || []).filter(
    (day) => validateScheduleDay(day)
  );

  const disableCheckout = disabled || isFetchingQuote || !validScheduleDays.length;
  const showSubmitButton =
    !selectedPaymentMethod ||
    selectedPaymentMethod === "card" ||
    disableCheckout ||
    isSubmittingRequest;
  const showWalletButton = !showSubmitButton;

  return (
    <div>
      {/* Checkout with Apple/Google Pay */}
      <ExpressCheckoutButton
        className={classNames({ hidden: !showWalletButton })}
        handleRequestSuccess={handleRequestSuccess}
        checkTransactability={checkTransactability}
      />
      {/* Checkout with credit card */}
      <Button
        testId="submit-request-button"
        appearance="purple"
        disabled={disableCheckout}
        showSpinner={isSubmittingRequest}
        onClick={handleCreditCardSubmit}
        className={classNames({ hidden: !showSubmitButton })}
      >
        {canInstantBook(
          booking,
          listing,
          bookingDetailsForm?.watch('totalGuests')
        ) ? (
          <FormattedMessage
            id="booking_request_page.confirm_and_pay"
            defaultMessage="Confirm and pay"
          />
        ) : (
          <FormattedMessage
            id="booking_request_page.request_to_book"
            defaultMessage="Request to book"
          />
        )}
      </Button>
    </div>
  );
};
